import React, { useState } from "react";
import "./booking.css"
import { BsFillArrowRightCircleFill,BsFillArrowLeftCircleFill} from "react-icons/bs";
import { motion } from 'framer-motion';
import Banner from "../../components/Banner/Banner";
import bannerImg from '../../images/booking-page.png'

export const SliderData = [
  {
    text: "Easily book your taxi online by entering your name, pickup address, destination, journey date and time, and contact number."
  },
  {
    text: "Using modern technology, customers can book their taxis anytime, anywhere, through their phones, laptops, or computers with internet access."
  },
  {
    text: "White Cabs offers a range of services, including Leduc Taxi, shopping trips, business travel, and airport transportation."
  },
  {
    text: "Online taxi booking is a quick and hassle-free way to secure your ride without leaving your home."
  },
  {
    text: "No extra charges apply for online booking. Learn more about White Cabs and its services by visiting our website."
  }
];

const Booking = () => {
  const [current, setCurrent] = useState(0);
  const length = SliderData.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (!Array.isArray(SliderData) || SliderData.length <= 0) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="booking container"
    >
      <Banner
        comp2="about"
        comp="home"
        title="Simplify Your Travel with Our App"
        description="For over 10 years, White Cabs has been the trusted name for safe, reliable transportation in Leduc. Download our app today and enjoy the ease of online taxi booking. Experience stress-free travel with White Cabs!"
        bannerImg={bannerImg}
      />
      <div className="booking__container">
        <div className="booking__left">
          <h2>How to Book a Taxi Online</h2>
          <div className="steps__container">
            <BsFillArrowLeftCircleFill
              className="left-arrow"
              onClick={prevSlide}
              aria-label="Previous Slide"
            />
            {SliderData.map((slide, index) => (
              <div
                className={index === current ? "slide active" : "slide"}
                key={index}
              >
                {index === current && (
                  <div className="ticket">
                    <div className="ticket-header">
                      <h2>White Cabs - Booking Ticket</h2>
                    </div>
                    <div className="ticket-content">
                      <p>{slide.text}</p>
                      <div className="ticket-divider"></div>
                      <div className="ticket-footer">
                        <p>Your Trusted Taxi Service in Leduc</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
            <BsFillArrowRightCircleFill
              className="right-arrow"
              onClick={nextSlide}
              aria-label="Next Slide"
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
};


export default Booking;
